// EmailConnect.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "../AuthContext";
import "./emailconnect.css";

const apiUrl = process.env.REACT_APP_API_URL;

const EmailConnect = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userData = { email, password };

    fetch(`${apiUrl}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(err.message || "Eroare la autentificare");
          });
        }
        return response.json();
      })
      .then((data) => {
        setUser(data); // ✅ setează userul în context
        navigate("/functionalpagelogin"); // ✅ redirecționează
      })
      .catch((err) => setErrorMessage(err.message))
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="email-connect-container">
      <form className="email-connect-form" onSubmit={handleLogin}>
        <h2 className="email-connect-title">Conectare cu email</h2>

        {errorMessage && <div className="email-connect-error">{errorMessage}</div>}

        <div className="input-group-reg">
          <FontAwesomeIcon icon={faEnvelope} className="input-icon-reg" />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-reg with-icon"
            required
          />
        </div>

        <div className="input-group-reg" style={{ position: 'relative' }}>
          <FontAwesomeIcon icon={faLock} className="input-icon-reg" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Parola"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-reg with-icon"
            style={{ paddingRight: '45px' }}
            required
          />
          <FontAwesomeIcon
            icon={showPassword ? faEyeSlash : faEye}
            className="toggle-password-icon-email"
            onClick={() => setShowPassword(!showPassword)}
          />
        </div>

        <button type="submit" className="input-reg-submit" disabled={isLoading}>
          {isLoading ? "Se conectează..." : "Conectare"}
        </button>

        <div className="redirect-registrer">
          <Link to="/forgot-password" className="reset-password">
            Am uitat parola
          </Link>
          <div>
            <b className="redirect-reg-text">Nou pe Contalearn?</b>
            <Link to="/quiz-start" className="redirect-reg-link">
              <b className="redirect-reg-link">Creeaza-ti un cont</b>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EmailConnect;
